/**
 * React Query cache keys for chunk-scoped assignment session data.
 *
 * Uid sits after resultId so ['assignmentChunk', resultId] and
 * ['assignmentChunk', resultId, uid] stay prefixes of the longer keys.
 *
 * Main doc shell:  ['assignmentChunk', resultId, uid, '_main']
 * Chunk field:     ['assignmentChunk', resultId, uid, chunkType]
 * All for session: ['assignmentChunk', resultId, uid]
 *
 * Session list:    ['assignmentSessionList', uid, limit]
 * List prefix:     ['assignmentSessionList']
 */
import { auth } from '../firebase';

function cacheUid() {
  const uid = auth.currentUser && auth.currentUser.uid;
  return uid ? String(uid) : 'anonymous';
}

export const assignmentChunkKeys = {
  all: ['assignmentChunk'],
  forResult: (resultId) => ['assignmentChunk', String(resultId), cacheUid()],
  main: (resultId) => ['assignmentChunk', String(resultId), cacheUid(), '_main'],
  chunk: (resultId, chunkType) => ['assignmentChunk', String(resultId), cacheUid(), String(chunkType)],
  /** Page bundle: one network round-trip for main doc + listed chunk types. */
  bundle: (resultId, chunkTypesKey, stage = 'full') => [
    'assignmentChunk',
    String(resultId),
    cacheUid(),
    '_bundle',
    String(chunkTypesKey),
    String(stage),
  ],
  /** Local edits (bucket drag, publish flags) merged over fetched chunks on read. */
  override: (resultId) => ['assignmentChunk', String(resultId), cacheUid(), '_override'],
};

export const assignmentSessionListKeys = {
  all: ['assignmentSessionList'],
  list: (limit) => ['assignmentSessionList', cacheUid(), Math.max(1, Number(limit) || 10)],
};

export const userConfigKeys = {
  all: ['userConfig'],
  detail: (uid) => ['userConfig', String(uid || 'anonymous')],
};
